/* eslint-disable no-tabs */
import React, { useEffect } from 'react';
import {
  Form, Row, Col,
} from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import moment from 'moment';
import { generateFlightSearchInputs } from '../helper';
import translations from '../../../screens/Search/translations';
import { useI18nContext } from '../../../utils/I18n';
import { FlightSearchForm } from './MultiDestinationsFlightSearchForm';
import {AddItem, MultiCityFormWrapper, Panel, } from "./styles";
import { AddCircle } from '@solar-icons/react';
import { getMultiDestinationRange } from '../../../utils/helpers';

type MultiDestinationsFlightSearchFormProps = {
    airportOptions: SelectOption[];
    MultiCityMaxRoute: number;
    form: any;
  limitSuggestionHeight?: boolean;
  title?: string;
  className?: string;
  onClose: () => void;
  DestinationLocationCode?: string;
  OriginLocationCode?: string;
  DepartureDate?: any;

}
export function MultiDestinationsFlightSearchForm(props: MultiDestinationsFlightSearchFormProps) {
  const {
    airportOptions,
    MultiCityMaxRoute,
    form,
    limitSuggestionHeight,
    title = "Multi city search",
    className,
      onClose,
    DepartureDate,
  } = props;

  const {
    state: { t },
  } = useI18nContext();

  const multiCities = form.getFieldValue('multiCity');

const origin = form.getFieldValue("OriginLocationCode");
const destination = form.getFieldValue("DestinationLocationCode");
const departureDate = DepartureDate ?? form.getFieldValue("DepartureDate");

const firstDepartureDate = getMultiDestinationRange(departureDate);

const initialValue =
  multiCities?.length > 0
    ? multiCities.map((item) => ({
        ...item,
        DepartureDate: getMultiDestinationRange(item.DepartureDate)
      }))
    : [
        {
          OriginLocationCode: origin,
          DestinationLocationCode: destination,
          DepartureDate: firstDepartureDate,
        },
        ...generateFlightSearchInputs(1),
      ];
  

  useEffect(() => {
    form.setFieldsValue({
      trips: initialValue,
    });
  }, []);

  return (
    <Panel className={className} role="dialog" aria-modal="true" aria-label={title}>
      <Col span={24}>
          <Row gutter={8}>
            <Form.List name="trips" initialValue={initialValue}>
              {(fields, { add, remove }) => (
                <>
                  {fields.map((field) => (
                    <Col xs={24} lg={24} key={`itemWrapper${field.key}`}>
                      <Row>
                        {field.name > 0 && (
                          <Col>
                            {' '}
                            <CloseOutlined onClick={() => {
                              remove(field.name);
                              field.name === 1 && fields.length <= 2 ? onClose() : null
                            }} key={`outline${field.key}`} />
                          </Col>
                        ) }

                      </Row>
                      <MultiCityFormWrapper>
                        <FlightSearchForm
                            airportOptions={airportOptions}
                            field={field}
                            key={field.key}
                            form={form}
                          limitSuggestionHeight={limitSuggestionHeight}
                        />
                      </MultiCityFormWrapper>
                    </Col>
                  ))}

                  <Col xs={24} lg={24}>
                    <Form.Item>
                      <AddItem
                          onClick={ fields?.length === 5 ? null : add}
                          disabled={fields.length >= MultiCityMaxRoute}
                      >
                        <AddCircle />
                        {' '}
                        <span>{t(translations).addNewButton}</span>
                      </AddItem>
                    </Form.Item>
                  </Col>
                </>
              )}
            </Form.List>
          </Row>
        </Col>
      </Panel>
  );
}
